import { VideoPlayButtonDefaultBox } from './video-play-button.default.box';


export const VideoPlayButtonBox = VideoPlayButtonDefaultBox;
